/* eslint-env jquery */
import { getClassStartsWith } from '../scripts.js';
(function ($) {
  $(document).ready(headerInit);

  function headerInit() {
    $('header li[class*="btn"]').each(function () {
      const btnClasses = getClassStartsWith(this.className, 'btn');
      $(this).removeClass(btnClasses);
      const link = this.firstElementChild;
      $(link).addClass(`${btnClasses} d-block`);
    });
  }
})(jQuery);
